export enum MsgTypeUploadEnum {
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS'
  }
